export default __webpack_public_path__ + "img/device.699dd945.svg";